(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var ROOT_SELECTOR = [
    '#vstar-reviews',
    '.trustoo-reviews-wrapper',
    '.custom-vstar-review-widget',
    '#shopify-product-reviews',
    '#judgeme_product_reviews',
    '.jdgm-rev-widg',
    '.jdgm-widget.jdgm-review-widget',
    '#stamped-main-widget',
    '#looxReviews',
    '.yotpo-main-widget',
    '.spr-container',
  ].join(',');

  var SKIP_SELECTOR =
    '.jdgm-preview-badge, .stamped-product-reviews-badge, .shopify-product-reviews-badge, .main-product__block-rating, .product-icon-list, .custom-vstar-rating-widget, .trustoo-review-tab, #vstar-tab';

  function getMount() {
    return document.querySelector('[data-mn-reviews-mount]');
  }

  function productRow() {
    return document.querySelector('.m-main-product--wrapper');
  }

  function shouldSkip(node) {
    return !!(node && node.closest && node.closest(SKIP_SELECTOR));
  }

  function isRoot(node) {
    if (!node || node.nodeType !== 1 || shouldSkip(node)) return false;
    if (node.closest('[data-mn-reviews-mount]')) return false;
    return node.matches(ROOT_SELECTOR);
  }

  function uniqueRoots(nodes) {
    return nodes.filter(function (node, index, list) {
      return !list.some(function (other, otherIndex) {
        return otherIndex !== index && other !== node && other.contains(node);
      });
    });
  }

  function separateReviews() {
    var mount = getMount();
    var row = productRow();
    if (!mount || !row) return;

    var found = [];
    row.querySelectorAll(ROOT_SELECTOR).forEach(function (node) {
      if (isRoot(node)) found.push(node);
    });

    uniqueRoots(found).forEach(function (widget) {
      if (mount.contains(widget)) return;
      mount.appendChild(widget);
    });
  }

  var scheduled = false;
  function scheduleSeparate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      separateReviews();
    });
  }

  separateReviews();
  document.addEventListener('DOMContentLoaded', separateReviews);
  window.addEventListener('load', separateReviews);
  [80, 250, 800, 2000].forEach(function (delay) {
    setTimeout(separateReviews, delay);
  });

  if (window.MutationObserver) {
    var row = productRow();
    if (row) {
      new MutationObserver(scheduleSeparate).observe(row, {
        childList: true,
        subtree: true,
      });
    }
  }
})();
